import React from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function PrecisionCleaningProfessionalResults() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const carouselImages = [];
  return <section id="precision-cleaning-professional-results" className="relative w-full overflow-hidden bg-background py-20 md:py-32 lg:py-40" ref={ref}>
      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/central_texas_kitchen_living_area.png)] animate-[ken-burns_10s_ease-out_infinite_alternate]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/40 via-background/80 to-background" />
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes ken-burns {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }
      `
    }} />

      <div className="container relative z-10 mx-auto px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-[55%_45%] lg:gap-12 items-center">
          <div className={`flex flex-col justify-center ml-4 space-y-10 text-center lg:text-left transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6 relative z-10 bg-white/40 backdrop-blur-md p-6 lg:bg-transparent lg:backdrop-blur-none lg:p-0">
              <h1 className={`font-sans text-5xl font-black italic tracking-[-0.06em] text-primary uppercase sm:text-7xl xl:text-8xl leading-[0.85] transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"} hover:skew-x-[-2deg] flex flex-row flex-wrap justify-center gap-x-4 gap-y-2`}>
                <span className="whitespace-nowrap flex gap-x-4 transition-all duration-700">
                  <span className="transition-all duration-700" style={{
                  transitionDelay: '0.2s'
                }}>PURE</span>
                  <span className="transition-all duration-700 text-secondary" style={{
                  transitionDelay: '0.4s'
                }}>EFFORT</span>
                </span>
                <span className="transition-all duration-700" style={{
                transitionDelay: '0.6s'
              }}>PURE</span>
                <span className="transition-all duration-700 text-secondary" style={{
                transitionDelay: '0.8s'
              }}>PRIDE</span>
                <span className="transition-all duration-700" style={{
                transitionDelay: '1.0s'
              }}>PURE</span>
                <span className="transition-all duration-700 text-secondary" style={{
                transitionDelay: '1.2s'
              }}>DETAIL</span>
              </h1>
              <p className="font-medium text-foreground/80 max-w-2xl mx-auto leading-relaxed lg:mx-0 border-l-2 border-primary/30 pl-6 italic">Professional, punctual, and disciplined. Our owner-operated team delivers deep-clean transformations for homes and businesses that value perfection over the status quo.</p>
              
            </div>

            <div className="flex flex-col gap-4 sm:flex-row justify-center relative z-10">
              <Button asChild size="lg" variant="default" className="h-16 px-10 text-xl font-bold rounded-none shadow-lg transition-all hover:translate-y-[-4px] hover:shadow-xl active:translate-y-0">
                <Link to="/PureDetailBookingPage" className="group">
                  <CalendarCheck className="mr-3 h-8 w-8 text-secondary transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" />
                  Book Your Clean Today
                </Link>
              </Button>
              <Button asChild size="lg" variant="secondary" className="h-16 px-10 text-xl font-bold rounded-none shadow-sm transition-all hover:translate-y-[-2px]">
                
              </Button>
            </div>
          </div>

          <div className={`relative mx-auto w-full transition-all duration-1000 ease-out delay-200 group ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            
            
            
            
            
            

          </div>
        </div>
      </div>
    </section>;
}